import React, { useState, useEffect } from 'react';
import { BiSearchAlt } from "react-icons/bi";
import { URL } from '../../constant';
import { useLocation } from "react-router-dom";

const DelegateInfo = () => {
  const [searchCert, setSearchCert] = useState('');
  const [result, setResult] = useState(null);
  const [searching, setSearching] = useState(false);
  const [searched, setSearched] = useState(false); // Track if search has been performed
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const handleSearch = async () => {
    if (!searchCert.trim()) {
      setSearched(false);
      return; // Just return without alert
    }
    
    setSearching(true);
    setResult(null);
    setSearched(true);
    
    try {
      // Trim and remove any extra whitespace from the certificate number
      const trimmedCertNo = searchCert.trim();
      
      // Use the new search endpoint
      const response = await fetch(
        `${URL}/data/certificationInfo/search/delegate?certificateNo=${encodeURIComponent(trimmedCertNo)}`
      );
      
      const data = await response.json();
      
      if (data.success) {
        setResult(data.data);
      } else {
        setResult(null);
      }
    } catch (error) {
      console.error("Error searching certificate:", error);
      setResult(null);
    } finally {
      setSearching(false);
    }
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  // Clear result when input changes
  const handleInputChange = (e) => {
    setSearchCert(e.target.value);
    if (searched) {
      setSearched(false);
      setResult(null);
    }
  };

  return (
    <div id='delegateinfo' className='my-50 mx-50 flex flex-col gap-6'>
      <div className='flex flex-col items-center '>
        <p className='text-2xl text-darkblue'>DELEGATE'S CERTIFICATE INFO</p>
        <p className='text-darkblue'>Please enter your certificate number correctly as available on the certificate.</p>
      </div>

      <div className='w-full flex justify-center gap-3'>
        <input
          className='h-10 w-80 border rounded-lg border-gray-400 focus:border-lightblue indent-2 outline-none'
          type="text"
          placeholder='Certificate number'
          value={searchCert}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          disabled={searching}
        />
        <button
          className={`h-10 w-12 flex justify-center items-center rounded-lg cursor-pointer ${
            searching ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-buttonfrom to-buttonto hover:opacity-90'
          }`}
          onClick={handleSearch}
          disabled={searching}
        >
          <BiSearchAlt className='text-white text-2xl' />
        </button>
      </div>

      {searching ? (
        <div className='px-7 py-5 bg-lgray shadow-xl rounded-xl'>
          <p className='text-lg font-semibold text-gray-500'>Searching...</p>
        </div>
      ) : result ? (
        <div className='px-7 py-5 bg-lgray shadow-xl rounded-xl'>
          <div className='flex flex-col gap-5'>
            <div className='flex justify-between max-md:flex-col-reverse max-md:items-center'>
              <p className='text-lg font-semibold uppercase'>{result.delegateName}</p>
              <p className='text-lg font-semibold text-gray-500'>{result.certificateNo}</p>
            </div>
            <div className='w-full border border-gray-200' />
            <div className='flex-1 text-center'>
              <p className='font-medium'>Name of the Course</p>
              <p className='font-medium text-gray-500'>{result.nameOfTheCourse}</p>
            </div>
            <div className='flex max-md:flex-col max-md:gap-3'>
              <div className='flex flex-1 max-sm:flex-col max-sm:gap-3'>
                <div className='flex-1 text-center'>
                  <p className='font-medium'>Issue Date</p>
                  <p className='font-medium text-gray-500'>{result.issueDate || '-'}</p>
                </div>
                <div className='flex-1 text-center'>
                  <p className='font-medium'>Course End Date</p>
                  <p className='font-medium text-gray-500'>{result.expiryDate}</p>
                </div>
                <div className='flex-1 text-center'>
                  <p className='font-medium'>Status</p>
                  <p className='font-medium text-gray-500'>
                    {result.status}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : searched && !searching ? (
        <div className='px-7 py-5 bg-lgray shadow-xl rounded-xl'>
          <p className='text-lg font-semibold text-gray-500'>Enter certificate number correctly</p>
        </div>
      ) : null}

      <div className='w-full flex justify-center'>
        <div className='w-[500px] border border-gray-500' />
      </div>
    </div>
  );
};

export default DelegateInfo;